import { render, staticRenderFns } from "./TasksCategorical.vue?vue&type=template&id=71c07ac8&scoped=true&"
import script from "./TasksCategorical.vue?vue&type=script&lang=js&"
export * from "./TasksCategorical.vue?vue&type=script&lang=js&"
import style0 from "./TasksCategorical.vue?vue&type=style&index=0&id=71c07ac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c07ac8",
  null
  
)

export default component.exports